import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis-with-text.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "mb-6",
  style: {"width":"184px","height":"50px"},
  src: _imports_0,
  alt: "logo-genesis"
}, null, -1)
const _hoisted_3 = { class: "force-change-password-title" }
const _hoisted_4 = { class: "flex flex-col gap-2 items-center " }
const _hoisted_5 = { class: "text-gray-lp-600" }
const _hoisted_6 = {
  class: "rounded-lg p-2 border border-gray-lp-1600 flex flex-col gap-1",
  style: {"width":"457px"}
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row items-center justify-between text-gray-lp-300"
}
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row items-center justify-between text-gray-lp-300"
}
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = {
  key: 2,
  class: "flex flex-row items-center justify-between text-gray-lp-300"
}
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "otp-input-wrapper" }
const _hoisted_14 = { class: "otp-input" }
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-red-lp-100"
}
const _hoisted_16 = { class: "force-change-password-otp-button" }
const _hoisted_17 = { class: "force-change-password-otp-countdown" }
const _hoisted_18 = { id: "otp-captcha" }
const _hoisted_19 = { class: "force-change-password-help" }
const _hoisted_20 = /*#__PURE__*/_createVNode("a", {
  class: "text-red-lp-100 underline",
  href: "mailto:system@thelionparcel.com"
}, "system@thelionparcel.com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("verificationAccount.otp.title")), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("verificationAccount.otp.description")), 1),
      _createVNode("div", _hoisted_6, [
        (_ctx.email)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("verificationAccount.otp.userEmail")), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.email), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.emailPartner)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("verificationAccount.otp.partnerClientEmail")), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.emailPartner), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.phoneNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("verificationAccount.otp.partnerClientPhone")), 1),
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.phoneNumber), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
          return _createVNode("div", {
            key: i,
            class: "force-change-password-otp-input"
          }, [
            _createVNode(_component_LpInput, {
              "data-testid": 'auth-verification-otp-input-' + i,
              type: "number",
              modelValue: _ctx.otp[i - 1],
              maxLength: 1,
              max: 1,
              error: _ctx.errorOTP,
              onEvent: ($event: any) => (_ctx.onInput($event, i - 1)),
              onKeydown: _ctx.onKeyDown,
              onPaste: _ctx.onPaste,
              onEnter: _ctx.verifyOTP
            }, null, 8, ["data-testid", "modelValue", "error", "onEvent", "onKeydown", "onPaste", "onEnter"])
          ])
        }), 64))
      ]),
      (_ctx.errorMessageOTP)
        ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(_ctx.errorMessageOTP), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_LpButton, {
        "data-testid": "auth-verification-otp-button-verify",
        title: _ctx.$t('verificationAccount.otp.verify'),
        isWidthFull: "",
        fontWeight: "semibold",
        disabled: !_ctx.isOTPValid || _ctx.loadingVerifyOTP,
        onClick: _ctx.verifyOTP
      }, null, 8, ["title", "disabled", "onClick"])
    ]),
    _createVNode("div", _hoisted_17, [
      (!_ctx.canRequestOTP)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t("verificationAccount.otp.resendIn", { countDown: _ctx.countDown })), 1)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.$t("verificationAccount.otp.notReceivedCode")) + " ", 1),
            _createVNode("button", {
              class: "font-bold text-red-lp-100",
              "data-testid": "auth-verification-otp-link-resend",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.requestOTP && _ctx.requestOTP(...args)))
            }, _toDisplayString(_ctx.$t("verificationAccount.otp.resend")), 1)
          ], 64))
    ]),
    _withDirectives(_createVNode("div", _hoisted_18, null, 512), [
      [_vShow, _ctx.showOTP]
    ]),
    _createVNode("div", _hoisted_19, [
      _createTextVNode(_toDisplayString(_ctx.$t("verificationAccount.helpWhatsApp")) + " ", 1),
      _createVNode("a", {
        class: "text-red-lp-100 underline",
        href: `https://wa.me/${_ctx.cleanPhoneNumber(_ctx.phoneNumberHD)}`,
        target: "_blank"
      }, _toDisplayString(_ctx.phoneNumberHD), 9, ["href"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("verificationAccount.orEmailTo")) + " ", 1),
      _hoisted_20
    ])
  ]))
}